import React, { useState, useEffect, useContext } from "react";
import "./Rooftop_Solar.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { ServiceId } from "../../../../utils/apis/service/Service";
import { IDS } from "../../../../utils/common";
import { Context } from "../../../../utils/context";
import { useParams } from "react-router-dom";

import "swiper/css";
import "swiper/css/pagination";
import Common_heading from "../../../common/common_heading/Common_heading";

const Rooftop_Solar = () => {
  const sliderImages = [
    "/assets/images/services/service-inner/img-1.png",
    "/assets/images/services/service-inner/img-2.png",
    "/assets/images/services/service-inner/img-3.png",
    "/assets/images/services/service-inner/img-4.png",
    "/assets/images/services/service-inner/img-1.png",
    "/assets/images/services/service-inner/img-2.png",
    "/assets/images/services/service-inner/img-3.png",
    "/assets/images/services/service-inner/img-4.png",
  ];

  const { id } = useParams();
  const { IMG_URL } = useContext(Context);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [serviceName, setServiceName] = useState("");
  const [serviceImages, setServiceImages] = useState([]);

  const getRoofTopSolar = async () => {
    const res = await ServiceId(id);

    if (res?.success) {
      setServiceName(res?.data?.name || "");
      setServiceImages(res?.data?.service_images || []);
    }
  };

  useEffect(() => {
    if (id) {
      getRoofTopSolar();
    }
  }, [id]);

  return (
    <section className="Rooftop_Solar Key_Benefits">


      <Common_heading
          title={<>Service Photos Of {htmlToReactParser.parse(serviceName)}</>}
        />

      <div className="container-fluid">
        <div className="slider_wrapper mt-5">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={4}
            slidesPerGroup={1}
            loop
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 2 },
              576: { slidesPerView: 2.2 },
              768: { slidesPerView: 3 },
              992: { slidesPerView: 4 },
            }}
            className="my_swiper_holder"
          >
            {serviceImages.map((img) => (
              <SwiperSlide key={img.id}>
                <div className="slider_img_box">
                  <img
                    src={IDS?.IMG_URL + img.url}
                    className="slider_img"
                    alt="service"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Rooftop_Solar;
